import React, { useContext, useEffect, useState, useCallback } from 'react'
import { TenantContext } from '../../tenant/TenantContext';
import { Alert, Table, Card, Button, Row, Col } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { formatCurrency } from '../../util/Currency';
import { formatDate } from '../../util/Date';
import { getBillStatus } from '../../util/Lookup';
import { getAccountTypeNameFromId, getAccountTypeFromId } from './UserBillService'
import { PaymentCartContext } from 'pages/payment-cart/PaymentCartContext';
import { useNavigate } from 'react-router-dom';
import _ from "lodash";
import { faFileInvoice, faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { listUserBillsForAccount } from './UserBillService'
import { extractError } from 'api/ErrorUtil';
import { SecurityContext } from '../../security/SecurityContext';
import { PAGE_SIZE } from '../../config/config';

function UserBillsListPage(props) {
    const { businessConfig } = useContext(TenantContext);
    const { addToCart } = useContext(PaymentCartContext);
    const [userBillsData, setUserBillsData] = useState({});
    const [errors, setErrors] = useState({});
    const { accountId } = useParams();
    const navigate = useNavigate();
    const secCtx = useContext(SecurityContext);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalNumberOfPages, setTotalNumberOfPages] = useState(0);

    const fetchUserBills = useCallback(async (page, size) => {
        let userAccounts = secCtx.accounts.filter(acc => acc.id === accountId);
        try {
            let userBillsPage = await listUserBillsForAccount(accountId, page, size);
            setUserBillsData({
                userBills: userBillsPage.billMessages,
                accountTypes: businessConfig.accountTypes,
                account: userAccounts[0]
            })
            setTotalNumberOfPages(userBillsPage.totalNumberOfPages)
            setErrors({});
        } catch (error) {
            let errs = extractError(error);
            setUserBillsData({
                userBills: {},
                accountTypes: businessConfig.accountTypes,
                account: userAccounts[0]
            })
            console.log(errs)
            setErrors(errs);
        }

    });


    useEffect(() => {
        fetchUserBills(currentPage, PAGE_SIZE)
            .catch(error => {
                let errs = extractError(error);
                setErrors(errs);
            });

    }, [accountId, currentPage]);

    function gotoBillDetails(event, bill) {
        event.preventDefault();

        navigate('/user-bill-detail', { state: { userBillsData: { ...userBillsData, bill: bill } } });
    }

    function payBill(event, bill) {
        event.preventDefault();
        addToCart(bill.billId, 'BILL', { ...bill }, userBillsData.account,
            getAccountTypeFromId(userBillsData.account.accountTypeId, userBillsData.accountTypes),
            1);
        navigate('/checkout-form');

    }

    const handlePaging = async (page) => {
        if (page < 0) {
            alert("Reached the beginning of data set")
            page = 0;
        }
        if (page > totalNumberOfPages - 1) {
            alert("Reached the end of data set")
            page = totalNumberOfPages - 1;
        }
        setCurrentPage(page);
    }

    return (
        <>
            {!_.isEmpty(errors) && errors.httpStatus === 404 && <Alert key="info" variant="info">No Bills were found!</Alert>}
            {!_.isEmpty(errors) && errors.httpStatus !== 404 && <Alert key="error" variant="danger">{errors.message}</Alert>}
            {!_.isEmpty(userBillsData) &&

                <Card className="strpied-tabled-with-hover">
                    <Card.Header>
                        {<Card.Title><h6>{getAccountTypeNameFromId(userBillsData.account.accountTypeId, userBillsData.accountTypes)}</h6></Card.Title>}
                        <p className="card-category">
                            Click on Pay icon to pay a bill
                        </p>
                    </Card.Header>
                    <Card.Body className="table-full-width table-responsive px-0">

                        {!_.isEmpty(userBillsData.userBills) &&
                            <Row>
                                <Col className='d-flex justify-content-end'>
                                    <Button variant="dark" className="border-0 text-dark" onClick={(event) => { handlePaging(currentPage - 1) }}>
                                        <h6><FontAwesomeIcon icon={faArrowLeft} onClick={(event) => { handlePaging(currentPage - 1) }} />Previous Page</h6>
                                    </Button>
                                    &nbsp;<span className="border-0 text-dark btn"><h6>{currentPage + 1} of {totalNumberOfPages}</h6></span>
                                    &nbsp;<Button variant="dark" className="border-0 text-dark" onClick={(event) => { handlePaging(currentPage + 1) }}>
                                        <h6>Next Page<FontAwesomeIcon icon={faArrowRight} /></h6>
                                    </Button>
                                </Col>

                            </Row>}

                        <Table className="table-hover table-striped">
                            <thead>
                                <tr>
                                    <th className="border-0">ID</th>
                                    <th className="border-0">Amount Due</th>
                                    <th className="border-0">Bill Date</th>
                                    <th className="border-0">Due Date</th>
                                    <th className="border-0">Status</th>
                                    <th className="border-0">Account Number</th>
                                    <th className="border-0">Account Type</th>
                                    <th className="border-0">Bill Detail & Pay</th>
                                    <th className="border-0">Pay</th>
                                </tr>

                            </thead>
                            <tbody>
                                {
                                    !_.isEmpty(userBillsData.userBills) && userBillsData.userBills.map((bill, idx) => (
                                        <tr key={idx}>
                                            <td>{bill.billNumber}</td>
                                            <td>{formatCurrency(bill.amountDue / 100, businessConfig.locale, businessConfig.currency)}</td>
                                            <td>{formatDate(bill.billDate)}</td>
                                            <td>{formatDate(bill.dueDate)}</td>
                                            <td>{getBillStatus(bill.billStatus)}</td>
                                            <td>{userBillsData.account.number}</td>
                                            <td>
                                                {getAccountTypeNameFromId(userBillsData.account.accountTypeId, userBillsData.accountTypes)}
                                            </td>
                                            <td>
                                                <Button variant="dark" className="border-0 text-dark" onClick={(event) => gotoBillDetails(event, bill)}>
                                                    <FontAwesomeIcon icon={faFileInvoice} />
                                                </Button>
                                            </td>
                                            <td>
                                                {bill.billStatus !== 'PAID' && <Button variant="dark" className="border-0 text-dark" onClick={(event) => payBill(event, bill)}>
                                                    <FontAwesomeIcon icon={faFileInvoice} />
                                                </Button>}
                                                {bill.billStatus === 'PAID' && <span>This bill was paid</span>}
                                            </td>

                                        </tr>
                                    ))}
                            </tbody>
                        </Table>



                    </Card.Body>
                </Card>
            }
        </>
    )
}

export default UserBillsListPage;